import { render, staticRenderFns } from "./collapsible-search.vue?vue&type=template&id=088f615b&scoped=true"
import script from "./collapsible-search.vue?vue&type=script&lang=js"
export * from "./collapsible-search.vue?vue&type=script&lang=js"
import style0 from "./collapsible-search.vue?vue&type=style&index=0&id=088f615b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088f615b",
  null
  
)

export default component.exports